import config from '@/shared/config';

const { WP_URL } = config;

export const Header_menus: { label: string; href: string }[] = [
   { href: `${WP_URL}/about`, label: 'About' },
   // { href: `${WP_URL}/news`, label: 'News' },
   { href: `${WP_URL}/faq`, label: 'FAQ' },
   // { href: `${WP_URL}/cancard-aware`, label: 'Cancard Aware' },
   // { href: `${WP_URL}/resources`, label: 'Resources' },
   { href: `/clinics`, label: 'Clinic Directory' },
   { href: `${WP_URL}/police-guidance/`, label: 'Police Guidance' },
   // { href: `${WP_URL}/terms-conditions`, label: 'Terms & Conditions' },
   { href: `https://cancardstore.myshopify.com/`, label: 'Shop' },
   // { href: `${WP_URL}/contact`, label: 'Contact' },
];
